import React from "react";
import "./nodata.scss";
import { Link } from "react-router-dom";
import Logo from "../assets/img/fav.png";
const NoMatch = () => {
  return (
    <div className="InSidepageSection">
      <div className="wrapper">
        <div className="errors">
          <div>
            <img src={Logo} alt="Company Logo" />
            <h1>
              <span aria-hidden="true">
                <span className="fade-in" id="digit1">4</span>
                <span className="fade-in" id="digit2">0</span>
                <span className="fade-in" id="digit3">4</span>
              </span>
              <span style={{ position: "absolute", width: "1px", height: "1px", padding: 0, margin: "-1px", overflow: "hidden", clip: "rect(0,0,0,0)", whiteSpace: "nowrap", border: 0 }}>404 </span>
              Page Not Found
            </h1>
            <Link to="/" aria-label="Return to homepage">
              Return To Home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoMatch;
